export function isUndefined(inName: any): boolean {
    return inName === undefined;
}

export function isEmpty(inName: any): boolean {
    return inName === '';
}

export function isEmptyArray(arr: Array<any>): boolean {
    return !(_size(arr) > 0);
}

export function _size(obj): number {
    let size = 0;
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) { size++; }
    }
    return size;
}

export function _contains(key, data): boolean {
    return data.indexOf(key) >= 0;
}
